import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import withReactContent from 'sweetalert2-react-content';
import { LuTrash2, LuLogOut } from "react-icons/lu";
import { FaCamera } from "react-icons/fa";
import { LuPencilLine } from "react-icons/lu";
import { FiTrash2 } from "react-icons/fi";
import { LuPlus } from "react-icons/lu";
import Swal from "sweetalert2";
import axios from "axios";
import authoreditStyle from './AuthorEditPage.module.css'
import AuthorMainHeader from '../../components/AuthorMainHeader/AuthorMainHeader'
import SeeMoreButton from '../seemore/SeeMore'
require('typeface-poppins')

export default function AuthorEditPage() {

    const navigate = useNavigate();
    const MySwal = withReactContent(Swal);
    const { id } = useParams();
    const [expanded, setExpanded] = useState(false);
    const [proimage, setProimage] = useState('');
    const [authorsbook, setBooks] = useState([]);
    const [tempbook, setTempbook] = useState([]);
    const [user, setUser] = useState(null); // State to hold user details
    const [error, setError] = useState(null); // State to handle errors
    const [loading, setLoading] = useState(true);
    const [category1, setCategory1] = useState('');
    const [genre1, setGenre1] = useState('');
    const [region1, setRegion1] = useState('');
    const [events, setEvents] = useState([]);
    const [image, setImage] = useState(null);
    const visibleBooks = expanded
        ? authorsbook
        : authorsbook.slice(0, 3);
    const handleImageChange = (event) => {
        setImage(event.target.files[0]);
    };
    useEffect(() => {
        // Fetch user details from the backend
        const fetchUserDetails = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_author_data.php?id=${id}`);
                if (response.data.success) {
                    if (!response?.data.error) {
                        setProimage(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/images/author/${id}.jpg`);
                    }
                    setUser(response.data.user);
                    setBooks(response.data.authorsbook);
                    setGenre1(response.data.genres);
                    setRegion1(response.data.regions);
                    setCategory1(response.data.categories);
                    setEvents(response.data.events || []);

                }
                else {
                    setError(response.data.message);
                    navigate(`/`);
                    alert('User either Deactivate or Deleted')
                }
            } catch (err) {
                setError("Failed to fetch user details. Please try again later.");
            } finally {
                setLoading(false);
            }
        };
        fetchUserDetails();
    }, [id]);

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    const formatEventDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
        }).toUpperCase();
    };

    const handleLogout = async (e) => {
        e.preventDefault();

        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'You will be logged out of your account.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Logout',
            cancelButtonText: 'Cancel',
            confirmButtonColor: '#d33',
            cancelButtonColor: '#6c757d',
            reverseButtons: true
        });

        if (result.isConfirmed) {
            localStorage.clear();
            sessionStorage.clear();
            localStorage.removeItem('isLoggedIn');
            localStorage.removeItem('authorToken');
            navigate('/general-login');
        }
    };


    /*const handleLogout = (e) => {
        e.preventDefault();
        localStorage.clear();
        sessionStorage.clear();
        localStorage.removeItem('isLoggedIn');
        localStorage.removeItem('authorToken');
        navigate('/general-login');
    };*/


    // Contact Information popup
    const contactInformation = async () => {
        const { value: formData } = await MySwal.fire({
            title: 'Contact Information',
            html: (
                <div className='contactformPopup1'>
                    <div className='container'>
                        <div className="row mb-3 g-2">
                            <div className="col text-start">
                                <label className={`${authoreditStyle.contactinfoLabelpop} form-label`}>First Name</label>
                                <input type="text" className={`${authoreditStyle.contactformControl} form-control`} defaultValue={user.f_name} name="fname" placeholder="First Name" id="firstName" />
                            </div>
                            <div className="col text-start">
                                <label className={`${authoreditStyle.contactinfoLabelpop} form-label`}>Last name</label>
                                <input type="text" className={`${authoreditStyle.contactformControl} form-control`} defaultValue={user.l_name} name="lname" placeholder="Last name" id="lastName" />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col text-start">
                                <label className={`${authoreditStyle.contactinfoLabelpop} form-label`}>Enter email address</label>
                                <input type="email" className={`${authoreditStyle.contactformControl} form-control`} defaultValue={user.email_id} placeholder="Enter email address here" id="registerEmail" disabled />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col text-start">
                                <label className={`${authoreditStyle.contactinfoLabelpop} form-label`}>Enter phone number</label>
                                <input type="tel" className={`${authoreditStyle.contactformControl} form-control`} defaultValue={user.phone && user.phone.slice(0, 10)} placeholder="Enter phone number here" name="phone" id="phoneNumber" maxLength={10} />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col text-start">
                                <label className={`${authoreditStyle.contactinfoLabelpop} form-label`}>Enter your website address</label>
                                <input type="text" className={`${authoreditStyle.contactformControl} form-control`} defaultValue={user.website} placeholder="Enter your website address" name="website" id="websiteUrl" />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col text-start">
                                <label className={`${authoreditStyle.contactinfoLabelpop} form-label`}>Hometown Zip Code</label>
                                <input type="text" className={`${authoreditStyle.contactformControl} form-control`} defaultValue={user.zipcode} placeholder="Hometown Zip Code" name="zipcode" id="zipCode" />
                                <input type="hidden" name="author_id" id="author_id" value={id} />
                                <input type="hidden" name="action" id="action" value="contact" />
                            </div>
                        </div>
                    </div>
                </div>
            ),
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: 'Save',
            focusConfirm: false,
            customClass: {
                popup: `${authoreditStyle.contactformPopup}`,
                confirmButton: `${authoreditStyle.contactinfosaveButton}`,
                closeButton: `${authoreditStyle.contactinfocloseButton}`,
                cancelButton: `${authoreditStyle.coninfocancelButton}`,
                title: `${authoreditStyle.contactinfopopTitle}`,
                actions: `${authoreditStyle.contactInfoaction}`,
            },
            preConfirm: () => {
                const fname = document.getElementById('firstName').value;
                const lname = document.getElementById('lastName').value;
                const phone = document.getElementById('phoneNumber').value;
                const website = document.getElementById('websiteUrl').value;
                const zipcode = document.getElementById('zipCode').value;
                const author_id = document.getElementById('author_id').value;
                const action = document.getElementById('action').value;

                /*if (!fname || !lname || !phone || !website || !zipcode || !author_id || !action) {
                    Swal.showValidationMessage('Please fill in all fields');
                    return false;
                }*/
                return { fname, lname, phone, website, zipcode, author_id, action };
            },
        });

        if (formData) {
            try {
                const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/register_profile_update.php`, formData);
                if (response.data.message) {
                    Swal.fire({
                        title: "Updated Successfully!",
                        text: "Redirecting to your profile...",
                        icon: "success",
                        timer: 2000, // Pop-up duration in milliseconds
                        showConfirmButton: false, // No need for a confirmation button
                    }).then(() => {
                        window.location.reload();
                    });
                } else {
                    alert(response.data.message);
                }
            } catch (error) {
                console.error("Error submitting form", error);
                alert("Error submitting form");
            }
        }
    };

    // More Information popup
    const moreInformation = async () => {
        const { value: formData } = await MySwal.fire({
            title: 'More Information',
            html: (
                <div className='contactformPopup1'>
                    <div className='container'>
                        <div className="row mb-2">
                            <div className="col text-start">
                                <label className={`${authoreditStyle.moreinfoFormlabel} form-label`}>Willing to Travel</label>
                                <select className={`${authoreditStyle.moreinfoFormSelect} form-select`} id="willingTravel">
                                    <option>Willing to Travel?</option>
                                    <option value="1" selected={user.willingtotravel ? "selected" : ""}>Yes</option>
                                    <option value="0" selected={user.willingtotravel ? "" : "selected"}>No</option>
                                </select>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col text-start">
                                <label className={`${authoreditStyle.moreinfoFormlabel} form-label`}>Region</label>
                                <select className={`${authoreditStyle.moreinfoFormSelect} form-select`} id="selectRegion" onChange={(e) => setRegion1(e.target.value)}>
                                    <option value="">Select Region</option>
                                    {region1.length > 0 ? (
                                        region1.map((region1, index) => (
                                            <option value={region1.region_name} selected={user.region == region1.region_name ? "selected" : ""}>{region1.region_name}</option>
                                        ))
                                    ) : (
                                        <div>No Result Found</div>
                                    )}
                                </select>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col text-start">
                                <label className={`${authoreditStyle.moreinfoFormlabel} form-label`}>Category</label>
                                <select className={`${authoreditStyle.moreinfoFormSelect} form-select`} id="selectCategory" onChange={(e) => setCategory1(e.target.value)}>
                                    <option value="">Select Category</option>
                                    {category1.length > 0 ? (
                                        category1.map((category1, index) => (
                                            <option value={category1.category_name} selected={user.category == category1.category_name ? "selected" : ""}>{category1.category_name}</option>
                                        ))
                                    ) : (
                                        <div>No Result Found</div>
                                    )}
                                </select>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col text-start">
                                <label className={`${authoreditStyle.moreinfoFormlabel} form-label`}>Genre</label>
                                <select className={`${authoreditStyle.moreinfoFormSelect} form-select`} id="selectGenre" onChange={(e) => setRegion1(e.target.value)}>
                                    <option value="">Select Genre</option>
                                    {genre1.length > 0 ? (
                                        genre1.map((genre1, index) => (
                                            <option value={genre1.genre_name} selected={user.genre == genre1.genre_name ? "selected" : ""}>{genre1.genre_name}</option>
                                        ))
                                    ) : (
                                        <div>No Result Found</div>
                                    )}
                                </select>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col text-start">
                                <label className={`${authoreditStyle.moreinfoFormlabel} form-label`}>Author or Illustrator</label>
                                <select className={`${authoreditStyle.moreinfoFormSelect} form-select`} id="authorIllus">
                                    <option value="">Select Author</option>
                                    <option value="0" selected={user.authororillustrator === 0 ? "selected" : ""}>Author</option>
                                    <option value="1" selected={user.authororillustrator === 1 ? "selected" : ""}>Illustrator</option>
                                    <option value="2" selected={user.authororillustrator === 2 ? "selected" : ""}>Author & Illustrator</option>
                                </select>
                                <input type="hidden" name="author_id" id="author_id" value={id} />
                                <input type="hidden" name="action" id="action" value="more" />
                            </div>
                        </div>
                    </div>
                </div>
            ),
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: 'Save',
            focusConfirm: false,
            customClass: {
                popup: `${authoreditStyle.moreinfoPopup}`,
                title: `${authoreditStyle.moreinfopopTitle}`,
                confirmButton: `${authoreditStyle.moreinfopopsaveButton}`,
                closeButton: `${authoreditStyle.moreinfopopcloseButton}`,
                cancelButton: `${authoreditStyle.moreinfopopcancelButton}`,
                htmlContainer: `${authoreditStyle.moreinfopopContainer}`,
                actions: `${authoreditStyle.moreinfopopActions}`,
            },
            preConfirm: () => {
                const willingtotravel = document.getElementById('willingTravel').value;
                const region = document.getElementById('selectRegion').value;
                const category = document.getElementById('selectCategory').value;
                const genre = document.getElementById('selectGenre').value;
                const authororillustrator = document.getElementById('authorIllus').value;
                const author_id = document.getElementById('author_id').value;
                const action = document.getElementById('action').value;

                /*if (!willingtotravel || !region || !category || !genre || !authororillustrator || !author_id || !action) {
                    Swal.showValidationMessage('Please fill in all fields');
                    return false;
                } */
                return { willingtotravel, region, category, genre, authororillustrator, author_id, action };
            },
        });
        if (formData) {
            try {
                const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/register_profile_update.php`, formData);
                if (response.data.message) {


                    Swal.fire({
                        title: "Updated Successfully!",
                        text: "Redirecting to your profile...",
                        icon: "success",
                        timer: 2000, // Pop-up duration in milliseconds
                        showConfirmButton: false, // No need for a confirmation button
                    }).then(() => {
                        window.location.reload();
                    });
                } else {
                    alert(response.data.message);
                }
            } catch (error) {
                console.error("Error submitting form", error);
                alert("Error submitting form");
            }
        }
    };

    // Award & Recognition popup
    const awardRecognition = async () => {
        const { value: formData } = await MySwal.fire({
            title: 'Awards & Recognition',
            html: (
                <div className='awardRecognition1'>
                    <div className='container'>
                        <div className="row">
                            <div className="col">
                                <textarea className={`${authoreditStyle.awardRecognitiontextarea} form-control`} id="awardsRecog" rows="5">{user.awardnrec}</textarea>
                                <input type="hidden" name="author_id" id="author_id" value={id} />
                                <input type="hidden" name="action" id="action" value="award" />
                            </div>
                        </div>
                    </div>
                </div>
            ),
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: 'Save',
            focusConfirm: false,
            customClass: {
                popup: `${authoreditStyle.awardRecognitionpopup}`,
                title: `${authoreditStyle.awardRecognitionTitle}`,
                confirmButton: `${authoreditStyle.awardRecognitionsaveButton}`,
                closeButton: `${authoreditStyle.awardRecognitioncloseButton}`,
                cancelButton: `${authoreditStyle.awardRecognitioncancelButton}`,
                actions: `${authoreditStyle.awardRecognitionactions}`,
                htmlContainer: `${authoreditStyle.awardRecognitioncontainer}`,
            },
            preConfirm: () => {
                const awardtextarea = document.getElementById('awardsRecog').value;
                const author_id = document.getElementById('author_id').value;
                const action = document.getElementById('action').value;

                if (!awardtextarea || !author_id || !action) {
                    Swal.showValidationMessage('Please fill this fields');
                    return false;
                }
                return { awardtextarea, author_id, action };
            },
        });
        if (formData) {
            try {
                const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/register_profile_update.php`, formData);
                if (response.data.message) {

                    Swal.fire({
                        title: "Updated Successfully!",
                        text: "Redirecting to your profile...",
                        icon: "success",
                        timer: 2000, // Pop-up duration in milliseconds
                        showConfirmButton: false, // No need for a confirmation button
                    }).then(() => {
                        window.location.reload();
                    });
                } else {
                    alert(response.data.message);
                }
            } catch (error) {
                console.error("Error submitting form", error);
                alert("Error submitting form");
            }
        }
    };

    // Biography Text popup
    const biography = async () => {
        const { value: formData } = await MySwal.fire({
            title: 'Biography',
            html: (
                <div className='awardRecognition1'>
                    <div className='container'>
                        <div className="row">
                            <div className="col">
                                <textarea className={`${authoreditStyle.biographyFormcontrol} form-control`} id="biographyText" rows="8">{user.biography}</textarea>
                                <input type="hidden" name="author_id" id="author_id" value={id} />
                                <input type="hidden" name="action" id="action" value="bio" />
                            </div>
                        </div>
                    </div>
                </div>
            ),
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: 'Save',
            focusConfirm: false,
            customClass: {
                popup: `${authoreditStyle.biographyPopup}`,
                title: `${authoreditStyle.biographypopupTitle}`,
                confirmButton: `${authoreditStyle.biographysaveButton}`,
                closeButton: `${authoreditStyle.biographycloseButton}`,
                cancelButton: `${authoreditStyle.biographycancelButton}`,
            },
            preConfirm: () => {
                const biography = document.getElementById('biographyText').value;
                const author_id = document.getElementById('author_id').value;
                const action = document.getElementById('action').value;

                if (!biography || !author_id || !action) {
                    Swal.showValidationMessage('Please fill this fields');
                    return false;
                }
                return { biography, author_id, action };
            },
        });
        if (formData) {
            try {
                const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/register_profile_update.php`, formData);
                if (response.data.message) {

                    Swal.fire({
                        title: "Updated Successfully!",
                        text: "Redirecting to your profile...",
                        icon: "success",
                        timer: 2000, // Pop-up duration in milliseconds
                        showConfirmButton: false, // No need for a confirmation button
                    }).then(() => {
                        window.location.reload();
                    });
                } else {
                    alert(response.data.message);
                }
            } catch (error) {
                console.error("Error submitting form", error);
                alert("Error submitting form");
            }
        }
    };

    // Note to Family popup
    const notetoFamily11 = async () => {
        let textValue = user.notetofamilies || "";
        const maxLength = 1000;
        const { value: formData } = await MySwal.fire({
            title: 'Note to Audience',
            html: (
                <div className='awardRecognition1'>
                    <div className='container'>
                        <div className="row">
                            <div className="col">
                                <textarea className={`${authoreditStyle.notetoFamilytextarea} form-control`} id="notefamilyText" rows="8">{user.notetofamilies}</textarea>
                                {/* character counter */}
                                <div
                                    id="charCount"
                                    style={{
                                        position: 'absolute',
                                        right: '10px',
                                        bottom: '5px',
                                        fontSize: '12px',
                                        color: '#666'
                                    }}
                                >
                                    {textValue.length}/{maxLength}
                                </div>
                                <input type="hidden" name="author_id" id="author_id" value={id} />
                                <input type="hidden" name="action" id="action" value="fam" />
                            </div>
                        </div>
                    </div>
                </div>
            ),
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: 'Save',
            focusConfirm: false,
            customClass: {
                popup: `${authoreditStyle.notetoFamilypopup}`,
                title: `${authoreditStyle.notetoFamilypopTitle}`,
                confirmButton: `${authoreditStyle.notetoFamilysavebutton}`,
                closeButton: `${authoreditStyle.notetoFamilyclosebutton}`,
                cancelButton: `${authoreditStyle.notetoFamilycancelbutton}`,
                htmlContainer: `${authoreditStyle.notetoFamilycontainer}`,
                actions: `${authoreditStyle.notetoFamilyactions}`,
            },
            preConfirm: () => {
                const notetofamilies = document.getElementById('notefamilyText').value;
                const author_id = document.getElementById('author_id').value;
                const action = document.getElementById('action').value;

                if (!notetofamilies || !author_id || !action) {
                    Swal.showValidationMessage('Please fill this fields');
                    return false;
                }
                return { notetofamilies, author_id, action };
            },
        });
        if (formData) {
            try {
                const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/register_profile_update.php`, formData);
                if (response.data.message) {

                    Swal.fire({
                        title: "Updated Successfully!",
                        text: "Redirecting to your profile...",
                        icon: "success",
                        timer: 2000, // Pop-up duration in milliseconds
                        showConfirmButton: false, // No need for a confirmation button
                    }).then(() => {
                        window.location.reload();
                    });
                } else {
                    alert(response.data.message);
                }
            } catch (error) {
                console.error("Error submitting form", error);
                alert("Error submitting form");
            }
        }
    };

    const notetoFamily = async () => {
        const maxLength = 1000;

        const { value: formData } = await MySwal.fire({
            title: 'Note to Audience',
            width: '800px',
            html: `
            <div class="awardRecognition1">
                <div class="container">
                    <div class="row">
                        <div class="col" style="position:relative">

                            <textarea
                                id="notefamilyText"
                                class="${authoreditStyle.notetoFamilytextarea} form-control"
                                rows="8"
                                maxlength="${maxLength}"
                            >${user.notetofamilies || ""}</textarea>

                            <div
                                id="charCount"
                                style="
                                    font-size:12px;
                                    color:#666;
                                    margin-top: 10px;
                                    text-align: end;
                                "
                            >
                                ${(user.notetofamilies || "").length}/${maxLength}
                            </div>

                            <input type="hidden" id="author_id" value="${id}" />
                            <input type="hidden" id="action" value="fam" />

                        </div>
                    </div>
                </div>
            </div>
        `,

            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: 'Save',
            focusConfirm: false,

            didOpen: () => {
                const textarea = document.getElementById('notefamilyText');
                const counter = document.getElementById('charCount');

                textarea.addEventListener('input', () => {
                    const len = textarea.value.length;
                    counter.innerText = `${len}/${maxLength}`;
                });
            },

            preConfirm: () => {
                const notetofamilies = document.getElementById('notefamilyText').value;
                const author_id = document.getElementById('author_id').value;
                const action = document.getElementById('action').value;

                if (!notetofamilies || !author_id || !action) {
                    Swal.showValidationMessage('Please fill all fields');
                    return false;
                }

                return { notetofamilies, author_id, action };
            },
        });

        if (formData) {
            try {
                const response = await axios.post(
                    `${process.env.REACT_APP_API_BASE_URL}authormeetapi/register_profile_update.php`,
                    formData
                );

                if (response.data.message) {
                    Swal.fire({
                        title: "Updated Successfully!",
                        text: "Redirecting to your profile...",
                        icon: "success",
                        timer: 2000,
                        showConfirmButton: false,
                    }).then(() => {
                        window.location.reload();
                    });
                } else {
                    alert(response.data.message);
                }
            } catch (error) {
                console.error("Error submitting form", error);
                alert("Error submitting form");
            }
        }
    };



    // Note to Host popup
    const notetoHost = async () => {
        const { value: formData } = await MySwal.fire({
            title: 'Note to Host',
            html: (
                <div className='notetohost'>
                    <div className='container'>
                        <div className="row">
                            <div className="col">
                                <textarea className={`${authoreditStyle.notetohostTextara} form-control`} id="notehostText" rows="8">{user.notetohost}</textarea>
                                <input type="hidden" name="author_id" id="author_id" value={id} />
                                <input type="hidden" name="action" id="action" value="host" />
                            </div>
                        </div>
                    </div>
                </div>
            ),
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: 'Save',
            focusConfirm: false,
            customClass: {
                popup: `${authoreditStyle.notetohostPopup}`,
                title: `${authoreditStyle.notetohostpopTitle}`,
                confirmButton: `${authoreditStyle.notetohostsaveButton}`,
                closeButton: `${authoreditStyle.notetohostcloseButton}`,
                cancelButton: `${authoreditStyle.notetohostcancelButton}`,
                actions: `${authoreditStyle.notetohostActions}`,
                htmlContainer: `${authoreditStyle.notetohostContainer}`
            },
            preConfirm: () => {
                const notetohost = document.getElementById('notehostText').value;
                const author_id = document.getElementById('author_id').value;
                const action = document.getElementById('action').value;

                if (!notetohost) {
                    Swal.showValidationMessage('Please fill this fields');
                    return false;
                }
                return { notetohost, author_id, action };
            },
        });
        if (formData) {
            try {
                const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/register_profile_update.php`, formData);
                if (response.data.message) {

                    Swal.fire({
                        title: "Updated Successfully!",
                        text: "Redirecting to your profile...",
                        icon: "success",
                        timer: 2000, // Pop-up duration in milliseconds
                        showConfirmButton: false, // No need for a confirmation button
                    }).then(() => {
                        window.location.reload();
                    });
                } else {
                    alert(response.data.message);
                }
            } catch (error) {
                console.error("Error submitting form", error);
                alert("Error submitting form");
            }
        }
    };

    // ProfileUpdate popup    
    const profileUpdate11 = async () => {
        const { value: formData } = await Swal.fire({
            title: 'Upload New Profile Image',
            html: `
            <div class="awardRecognition1">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-lg-12">
                    <label class="form-label pb-4 mb-0">Choose an image that will appear on your Author profile page.</label>
                    <label class="form-label">Upload new image:</label>
                    <div class="dropArea">
                        <span class="dropareaIcon">
                            <img src="" />
                        </span>
                        <p class="dropareaParagraph"> Click or drag and drop to upload your file </p>
                        <span class="dropareaText"> PNG or JPG </span>
                        <div class="text-center">
                            <input type="file" accept="image/*" id="fileInput" class="chooseInput" />       
                        </div>
                    </div>                    
                  </div>
                </div>
              </div>
            </div>`,
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: 'Save',
            focusConfirm: false,
            customClass: {
                popup: `${authoreditStyle.profileUpdatepopup}`,
                title: `${authoreditStyle.profileUpdatetitle}`,
                confirmButton: `${authoreditStyle.profilesveaButton}`,
                closeButton: `${authoreditStyle.profilecloseButton}`,
                cancelButton: `${authoreditStyle.profileCancelbutton}`,
            },
            didOpen: () => {
                // Attach the event listener after the modal is opened
                const fileInput = document.getElementById('fileInput');
                fileInput.addEventListener('change', handleImageChange); // Attach handler
            },
            willClose: () => {
                // Clean up event listener when the modal is closed
                const fileInput = document.getElementById('fileInput');
                fileInput.removeEventListener('change', handleImageChange);
            },
            preConfirm: async () => {
                const fileInput = document.getElementById('fileInput');
                if (!fileInput.files[0]) {
                    Swal.showValidationMessage('Please select an image before saving.');
                    return false;
                }

                const formData = new FormData();
                formData.append('auid', id);
                formData.append('image', fileInput.files[0]);


                try {
                    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/upload_author_pic.php`, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    });
                    // console.log("response", response)
                    if (response.data.success) {

                        // const reader = new FileReader();
                        // reader.onloadend = () => {
                        //     setProimage(reader.result);
                        // };
                        // reader.readAsDataURL(fileInput.files[0]);

                        const file = fileInput.files[0];

                        if (file) {
                            const imageURL = URL.createObjectURL(file);
                            setProimage(imageURL);
                        }

                        // console.log(response.data);
                        await MySwal.fire({
                            icon: 'success',
                            title: 'File uploaded successfully.',
                            showConfirmButton: false,
                            timer: 2000, // auto-close after 2 seconds
                        });
                        // window.location.reload();
                    }
                    else if (response?.data.error) {
                        // console.log("image size error :", response?.data.error)
                        MySwal.fire({
                            icon: 'error',
                            title: 'Upload Failed',
                            text: response?.data.error,
                        });
                    }

                } catch (error) {
                    console.error('Error uploading image:', error);
                }
            },
        });

        // if (formData) {
        //     console.log('Registration data:', formData);
        // }
    };

    const profileUpdate = async () => {
        await Swal.fire({
            title: 'Upload New Profile Image',
            html: `
      <div class="awardRecognition1">
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-12">
              <label class="form-label pb-4 mb-0">
                Choose an image that will appear on your Author profile page.
              </label>

              <label class="form-label">Upload new image:</label>

              <div class="dropArea">
                <span class="dropareaIcon">
                  <img id="previewImage" src="https://via.placeholder.com/100" />
                </span>

                <p class="dropareaParagraph">
                  Click or drag and drop to upload your file
                </p>

                <span class="dropareaText">PNG or JPG</span>

                <div class="text-center">
                  <input 
                    type="file" 
                    accept="image/png, image/jpeg, image/jpg, image/webp"
                    id="fileInput" 
                    class="chooseInput" 
                  />       
                </div>
              </div>                    
            </div>
          </div>
        </div>
      </div>
    `,
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: 'Save',
            focusConfirm: false,

            customClass: {
                popup: `${authoreditStyle.profileUpdatepopup}`,
                title: `${authoreditStyle.profileUpdatetitle}`,
                confirmButton: `${authoreditStyle.profilesveaButton}`,
                closeButton: `${authoreditStyle.profilecloseButton}`,
                cancelButton: `${authoreditStyle.profileCancelbutton}`,
            },

            didOpen: () => {
                const fileInput = document.getElementById('fileInput');
                const previewImage = document.getElementById('previewImage');

                if (fileInput) {
                    fileInput.addEventListener('change', () => {
                        const file = fileInput.files[0];

                        if (!file) return;

                        // ✅ Validate file type (Safari fix)
                        if (!file.type.match(/image\/(jpeg|png|jpg|webp)/)) {
                            Swal.showValidationMessage('Only JPG, PNG, or WEBP allowed.');
                            fileInput.value = '';
                            return;
                        }

                        // ✅ Use FileReader (Safari-safe)
                        const reader = new FileReader();
                        reader.onloadend = () => {
                            if (previewImage) {
                                previewImage.src = reader.result;
                            }
                        };
                        reader.readAsDataURL(file);
                    });
                }
            },

            preConfirm: async () => {
                const fileInput = document.getElementById('fileInput');

                if (!fileInput || !fileInput.files[0]) {
                    Swal.showValidationMessage('Please select an image before saving.');
                    return false;
                }

                const file = fileInput.files[0];

                // ✅ Validate again before upload
                if (!file.type.match(/image\/(jpeg|png|jpg|webp)/)) {
                    Swal.showValidationMessage('Only JPG, PNG, or WEBP allowed.');
                    return false;
                }

                const formData = new FormData();
                formData.append('auid', id);
                formData.append('image', file);

                try {
                    const response = await axios.post(
                        `${process.env.REACT_APP_API_BASE_URL}authormeetapi/upload_author_pic.php`,
                        formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                            },
                        }
                    );

                    if (response.data.success) {

                        // ✅ Update profile image (FileReader again for consistency)
                        const reader = new FileReader();
                        reader.onloadend = () => {
                            setProimage(reader.result);
                        };
                        reader.readAsDataURL(file);

                        await MySwal.fire({
                            icon: 'success',
                            title: 'File uploaded successfully.',
                            showConfirmButton: false,
                            timer: 2000,
                        });

                    } else if (response?.data.error) {
                        MySwal.fire({
                            icon: 'error',
                            title: 'Upload Failed',
                            text: response?.data.error,
                        });
                    }

                } catch (error) {
                    console.error('Error uploading image:', error);

                    MySwal.fire({
                        icon: 'error',
                        title: 'Upload Error',
                        text: 'Something went wrong while uploading.',
                    });
                }
            },
        });
    };

    let nji = Array();
    let delrec = Array();

    // BooklistISBN Component        
    function BooklistIsbn() {

        const [count3, setCount3] = useState([]);
        const [count2, setCount2] = useState([]);
        const [count1, setCount1] = useState(null); // Store book data here
        const [inputValue, setInputValue] = useState('');

        const handleInputChange = (event) => {
            setInputValue(event.target.value);
        };


        const handleSearchClick22 = async (idd) => {

            const element = document.getElementById(idd);
            if (element) {
                delrec.push(idd);
                element.style.display = 'none';
                // console.log(delrec);
            }
        }

       
        const handleSearchClick = async () => {
            if (inputValue !== undefined && inputValue !== '') {
                try {
                    const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/getbook.php?isbn=${inputValue}`);
                    //console.log(response, 'Response');
                    if (response.data.success) {

                        // Format the response data into a table format
                        const bookDetails = response.data.bookdetails;

                        setCount1(
                            <table className={`${authoreditStyle.resultTablebooklist} table table-borderless`}>
                                <thead>
                                    <tr>
                                        <th className='w-50 text-start'>Title</th>
                                        <th className='w-25'>Price</th>
                                        <th className='w-25'>Add</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className='w-50 text-start'>{bookDetails.TITLE[0]}</td>
                                        <td className='w-25'>$ {bookDetails.PRICE[0]}</td>
                                        <td className='w-25'>
                                            <button className={`${authoreditStyle.plusButtonbooklist} btn btn-primary`} onClick={() => handlePlusButtonClick(bookDetails.ISBN[0], bookDetails.TITLE[0], bookDetails.PRICE[0], id)}>
                                                <LuPlus className={authoreditStyle.plusIconbooklist} />
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        );

                    } else {
                        setCount1(<p>No record found</p>);
                        alert(response.data.message);
                    }
                } catch (err) {
                    alert(err);
                }
            }
        };


        const handlePlusButtonClick = async (isbn, title, price, id) => {

            setInputValue("")
            setCount1(null);

            const exists = authorsbook.some(book => book.isbn === isbn);
            if (exists && !(delrec.includes(isbn))) {


                alert("This book is already added.");
                return;
            }

            const exists1 = nji.some(book => book.isbn === isbn);

            if (exists1 && !(delrec.includes(isbn))) {

                alert("This book is already added.");
                return;
            }

            if (delrec.includes(isbn)) {

                delrec = delrec.filter(item => item !== isbn);

            }

            const newBook = { isbn, title, price };
            nji.push(newBook);

            setCount3(prevCount3 => [
                ...prevCount3,
                { isbn, title, price }
            ]);


            setCount2(
                prevCount2 => [
                    ...prevCount2.reverse(),
                    <tr id={isbn}>
                        <td>{title}</td>
                        <td>{isbn}</td>
                        <td>$ {price}</td>
                        <td className='text-center' onClick={() => handleSearchClick22(`${isbn}`)}><FiTrash2 className='trashicon' /></td>
                    </tr>
                ]
            );

        };

        console.log("delrec :" , delrec);
        return (
            <>
                <div className='row'>
                    <div className='col-lg-8'>
                        <div className="d-flex mb-3">
                            <input type="text" className={`${authoreditStyle.searchInputbooklist} form-control rounded-0`} value={inputValue} onChange={handleInputChange} placeholder="Enter ISBN" />
                            <button onClick={handleSearchClick} className={`${authoreditStyle.searchBtnbooklist} btn btn-danger rounded-0`} style={{ width: '30%' }}>
                                Search
                            </button>
                        </div>
                        <div className={authoreditStyle.findBooksResultsbooklist}>
                            <div className="table-responsive">
                                {count1}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className={`${authoreditStyle.tablelist}`}>
                            {/* <div className='table-responsive'>
                                <table className="table table-bordered" style={{ tableLayout: 'fixed', width: '100%' }}>
                                    <thead style={{ display: 'table', width: '100%', tableLayout: 'fixed' }}>
                                        <tr>
                                            <th style={{ width: '300px' }}>Title</th>
                                            <th>ISBN</th>
                                            <th>Price</th>
                                            <th className='text-center'>Delete</th>
                                        </tr>
                                    </thead>
                                    <tbody style={{
                                        display: 'block',
                                        maxHeight: '200px',
                                        overflowY: 'auto',
                                        width: '100%'
                                    }}>
                                        {count2}
                                        {authorsbook.map((book, index) => (
                                            <tr key={index} id={book.isbn} style={{
                                                display: 'table',
                                                width: '100%',
                                                tableLayout: 'fixed'
                                            }}>
                                                <td style={{ width: '300px' }}>{book.title}</td>
                                                <td>{book.isbn}</td>
                                                <td>$ {book.price}</td>
                                                <td className='text-center' onClick={() => handleSearchClick22(`${book.isbn}`)}>
                                                    <FiTrash2 className={authoreditStyle.booklisttrashIcon} />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div> */}

                            <div className={`${authoreditStyle.scrollContainer}`}>
                                <table className="table table-bordered" style={{ width: '100%', tableLayout: 'fixed' }}>
                                    <thead>
                                        <tr>
                                            <th style={{ width: '300px', position: 'sticky', top: 0, background: '#fff', zIndex: 2 }}>
                                                Title
                                            </th>
                                            <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 2 }}>
                                                ISBN
                                            </th>
                                            <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 2 }}>
                                                Price
                                            </th>
                                            <th className='text-center' style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 2 }}>
                                                Delete
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {authorsbook.map((book, index) => (
                                            <tr key={index} id={book.isbn}>
                                                <td style={{ width: '300px' }}>{book.title}</td>
                                                <td>{book.isbn}</td>
                                                <td>$ {book.price}</td>
                                                <td className='text-center'>
                                                    <FiTrash2 onClick={() => handleSearchClick22(book.isbn)} />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    // BookList popup
    const bookListpop = async () => {
        const { value: formData } = await MySwal.fire({
            title: `My Books: ${user.f_name} ${user.l_name}`,
            html: (
                <div className='bookListpopup'>
                    <div className='container'>
                        <BooklistIsbn />
                    </div>
                </div>
            ),
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: 'Save',
            focusConfirm: false,
            customClass: {
                popup: `${authoreditStyle.mainbooklistPopup}`,
                title: `${authoreditStyle.mainbooklistTitle}`,
                confirmButton: `${authoreditStyle.mainbooklistsaveButton}`,
                closeButton: `${authoreditStyle.mainbooklistcloseButton}`,
                cancelButton: `${authoreditStyle.mainbooklistcancelbutton}`,
            },
            preConfirm: async () => {
                // Check if either `nji` or `delrec` is not empty
                if (nji.length > 0 || delrec.length > 0) {
                    try {
                        // Make the POST request to the API
                        const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/addbookstoauthor.php`, {
                            add: nji,  // The books to be added
                            del: delrec,  // The books to be removed
                            auid: id  // Author ID
                        });


                        // Check the API response
                        if (response.data.success) {
                            //alert('Books successfully added or removed.');
                            // You can handle any further logic on success here
                            await MySwal.fire({
                                icon: 'success',
                                title: 'Books successfully added or removed!',
                                showConfirmButton: false,
                                timer: 2000, // auto-close after 2 seconds
                            });
                            window.location.reload();
                        } else {
                            alert('Failed to add or remove books.');
                        }
                    } catch (err) {
                        // Handle any errors that occur during the API request
                        alert('Error adding or removing books. Please try again.');
                        console.error(err);
                    }
                } else {
                    // Alert when no changes are made
                    alert('Please add or remove books before saving.');
                }
            },
        });
        // if (formData) {
        //     console.log('Registration data:', formData);
        // }
    };

    // Deactivate Account popup
    const deactivateAccount = async () => {
        const { value: formData } = await MySwal.fire({
            title: 'User Deactivate',
            html: (
                <div className='bookListpopup'>
                    <div className='container'>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className='tablelist'>
                                    <div className='table-responsive'>
                                        <input type="hidden" name="author_id" id="author_id" value={id} />
                                        <input type="hidden" name="action" id="action" value="deactivateAccount" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ),
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: 'Deactivate Account',
            focusConfirm: false,
            customClass: {
                popup: 'bookListpop',
                title: 'Deactivate Account',
                confirmButton: 'sveabutton1',
                closeButton: 'closebutton',
                cancelButton: 'canbutton',
            },
            preConfirm: () => {

                // const notetxthost = document.getElementById('notehostText').value;
                const author_id = document.getElementById('author_id').value;
                const action = document.getElementById('action').value;
                return { author_id, action };
                // if (!notetxthost) {
                //     Swal.showValidationMessage('Please fill this fields');
                //     return false;
                // }
                // return { notetxthost };
            },
        });
        if (formData) {
            // console.log('Registration data:', formData);
            try {
                const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/register_profile_update.php`, formData);
                if (response.data.message) {

                    Swal.fire({
                        title: "Author Deactivate Successfully!",
                        text: "Redirecting to your profile...",
                        icon: "success",
                        timer: 2000, // Pop-up duration in milliseconds
                        showConfirmButton: false, // No need for a confirmation button
                    }).then(() => {
                        // window.location.reload();
                        navigate(`/`);
                    });
                } else {
                    alert(response.data.message);
                }
            } catch (error) {
                console.error("Error submitting form", error);
                alert("Error submitting form");
            }
        }
    };

    // Delete Account popup
    /*const deleteAccount = async () => {
        
        const { value: formData } = await MySwal.fire({
        title: 'Delete Your Account',
        html: (
        <div className='deletepopup'>
            <div className='container'>
                <div className="row">
                    <div className="col-lg-12 text-start">
                        <h6> We're sorry to see you go </h6>
                        <p> By deleting your account, you will no longer be able to 
                            restore it. If you want to keep your account but not use 
                            it for a while, you can choose to deactivate your account intead.
                        </p>                                                      
                        <div className='tablelist'>
                            <div className='table-responsive'>
                                <input type="hidden" name="author_id" id="author_id" value={id} />
                                <input type="hidden" name="action" id="action" value="deleteAccount" />
                                  
                            </div>  
                        </div>                          
                    </div>                
                </div>                    
            </div>      
        </div>  
        ),
        showCancelButton: true,
        showCloseButton: true,        
        confirmButtonText: 'Delete Account',
        cancelButtonText: 'Deactivate Account',
        focusConfirm: false,        
        customClass: {                
        popup: `${authoreditStyle.maindeletePopup}`,
        title: `${authoreditStyle.maindeleteTitle}`,
        confirmButton: `${authoreditStyle.deletepopupButton}`,             
        closeButton: `${authoreditStyle.delpopupcloseButton}`,
        cancelButton: `${authoreditStyle.delpopdeactivateButton}`,
        },
        preConfirm: () => { 
            const confirmText = document.getElementById('confirmText').value;
            if (confirmText !== 'DELETE') {
                Swal.showValidationMessage('You must type DELETE to confirm');
                return false;
            }
               
        const author_id = document.getElementById('author_id').value;
        const action = document.getElementById('action').value;
        return { author_id, action };             
        },
        });

        if (formData) {
            // console.log('Registration data:', formData);
            try {
                const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/register_profile_updatee.php`, formData);
                if (response.data.message) {
            
                Swal.fire({
                title: "Author Deleted Successfully!",
                text: "Redirecting to your profile...",
                icon: "success",
                timer: 2000, // Pop-up duration in milliseconds
                showConfirmButton: false, // No need for a confirmation button
                }).then(() => {
                // window.location.reload();
                navigate(`/`);
                });
                } else {
                    alert(response.data.message);
                }
                } catch (error) {
                console.error("Error submitting form", error);
                alert("Error submitting form");
            }
          }
        };*/
    const deleteAccount = async () => {

        // FIRST POPUP
        const firstConfirm = await MySwal.fire({
            title: 'Delete Your Account',
            html: (
                <div className='deletepopup'>
                    <div className='container'>
                        <div className="row">
                            <div className="col-lg-12 text-start">
                                <h6>We're sorry to see you go</h6>
                                <p>
                                    By deleting your account, you will no longer be able to restore it.
                                    If you want to keep your account but not use it for a while,
                                    you can deactivate instead.
                                </p>

                                <input type="hidden" id="author_id" value={id} />
                                <input type="hidden" id="action" value="deleteAccount" />
                            </div>
                        </div>
                    </div>
                </div>
            ),
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: 'Delete Account',
            cancelButtonText: 'Deactivate Account',
            focusConfirm: false,
            customClass: {
                popup: authoreditStyle.maindeletePopup,
                title: authoreditStyle.maindeleteTitle,
                confirmButton: authoreditStyle.deletepopupButton,
                cancelButton: authoreditStyle.delpopdeactivateButton,
                closeButton: authoreditStyle.delpopupcloseButton,
            },
        });

        // If user clicks Cancel or Close
        if (!firstConfirm.isConfirmed) {
            deactivateAccount();
            return;
        }

        // SECOND CONFIRMATION POPUP
        const secondConfirm = await Swal.fire({
            title: 'Are you sure?',
            text: 'This action will permanently delete your account.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it',
            cancelButtonText: 'No, keep my account',
            confirmButtonColor: '#d33',
        });

        // If user cancels second popup
        if (!secondConfirm.isConfirmed) return;

        // API CALL AFTER FINAL CONFIRMATION
        try {
            const formData = {
                author_id: id,
                action: 'deleteAccount',
            };

            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}authormeetapi/register_profile_update.php`,
                formData
            );

            if (response.data.message) {
                Swal.fire({
                    title: "Author Deleted Successfully!",
                    text: "Redirecting to homepage...",
                    icon: "success",
                    timer: 2000,
                    showConfirmButton: false,
                }).then(() => {
                    navigate(`/`);
                });
            } else {
                Swal.fire("Error", response.data.message, "error");
            }
        } catch (error) {
            console.error("Error submitting form", error);
            Swal.fire("Error", "Error submitting form", "error");
        }
    };


    return (
        <>
            <AuthorMainHeader uname={user.f_name} />
            <div className={authoreditStyle.authoreditpage}>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <div className={`${authoreditStyle.authoreditNav} d-flex flex-wrap align-items-center`}>
                                <div className='me-auto'>
                                    <button className={`${authoreditStyle.saveprofilebtn} btn btn-primary d-flex align-items-center me-4`}> Save Profile </button>
                                </div>
                                <div className='d-flex align-items-center'>
                                    <button className={`${authoreditStyle.aedeleteButton} btn btn-danger d-flex align-items-center me-3`} onClick={deleteAccount}>
                                        <LuTrash2 className={`${authoreditStyle.aedeleteIcon} me-1`} /> Delete Account
                                    </button>
                                    {/* Logout Button */}
                                    <button className="btn btn-secondary d-flex align-items-center" onClick={handleLogout}>
                                        <LuLogOut className="me-1" /> Logout
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-4 col-xxl-4">
                            <div className='row'>
                                <div className='col-sm-12'>
                                    <div className={authoreditStyle.aepictureBox}>
                                        <div className={authoreditStyle.aepicturePreview}>
                                            <div className={authoreditStyle.aeimageWrap}>
                                                <img src={proimage} className={`img-fluid w-100 h-100 ${authoreditStyle.authorImage}`} />

                                            </div>
                                        </div>
                                        <div className={`${authoreditStyle.aepicturemainText} d-flex    align-items-end flex-column`}>
                                            <div className={`${authoreditStyle.aepicturetopText} mb-auto w-100`}>
                                                <h5>Profile Photo</h5>
                                            </div>
                                            <div className={`${authoreditStyle.aepicturechange} d-flex justify-content-end align-items-center`}>
                                                <span className='me-2'> Change </span>
                                                <button className={`${authoreditStyle.aecameraButton} btn btn-danger`} onClick={profileUpdate}>
                                                    <FaCamera className={authoreditStyle.aecameraIcon} />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-sm-12'>
                                    <div className={authoreditStyle.aecontactBoxes}>
                                        <div className={authoreditStyle.aecontactHeader}>
                                            <h4> Contact Info </h4>
                                            <button className={`${authoreditStyle.editButton} btn btn-light`} onClick={contactInformation}> Edit
                                                <LuPencilLine className={`${authoreditStyle.editButtonicon} ms-1`} />
                                            </button>
                                        </div>
                                        <div className={authoreditStyle.aecontactBody}>
                                            <div className={authoreditStyle.aecontactInfo}>
                                                <h5>Name</h5>
                                                <p>{user.f_name} {user.l_name}</p>
                                            </div>
                                            <div className={authoreditStyle.aecontactInfo}>
                                                <h5>Website</h5>
                                                <a href='#'>{user.website}</a>
                                            </div>
                                            <div className={authoreditStyle.aecontactInfo}>
                                                <h5>Email Address</h5>
                                                <p>{user.email_id}</p>
                                            </div>
                                            <div className={authoreditStyle.aecontactInfo}>
                                                <h5>Phone</h5>
                                                <p>{user.phone && user.phone.slice(0, 10)}</p>
                                            </div>
                                            <div className={authoreditStyle.aecontactInfo}>
                                                <h5>Hometown Zip Code</h5>
                                                <p>{user.zipcode}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-sm-12'>
                                    <div className={authoreditStyle.aemoreinfoBox}>
                                        <div className={authoreditStyle.aemoreinfoHeader}>
                                            <h4> More Info </h4>
                                            <button className={`${authoreditStyle.editButton} btn btn-light`} onClick={moreInformation}>Edit
                                                <LuPencilLine className={`${authoreditStyle.editButtonicon} ms-1`} />
                                            </button>
                                        </div>
                                        <div className={authoreditStyle.aemoreinfoBody}>
                                            <div className='table-responsive'>
                                                <table className='table table-borderless'>
                                                    <tbody>
                                                        <tr>
                                                            <th>Willing to Travel?</th>
                                                            <td>{user.willingtotravel ? 'yes' : 'No'}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Region</th>
                                                            <td>{user.region}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Category</th>
                                                            <td>{user.category}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Genre</th>
                                                            <td>{user.genre}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Author or Illustrator?</th>
                                                            <td>
                                                                {user.authororillustrator == 0 ? 'Author' :
                                                                    user.authororillustrator == 1 ? 'Illustrator' :
                                                                        'Author & Illustrator'}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-sm-12'>
                                    <div className={authoreditStyle.aeawardBox}>
                                        <div className={authoreditStyle.aeawardHeader}>
                                            <h4> Awards & Recognition </h4>
                                            <button className={`${authoreditStyle.editButton} btn btn-light ${authoreditStyle.gap5}`} onClick={awardRecognition}>Edit
                                                <LuPencilLine className={`${authoreditStyle.editButtonicon} ms-1`} />
                                            </button>
                                        </div>
                                        <div className={authoreditStyle.awardbody}>
                                            <p>{user.awardnrec}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-8 col-xxl-8">
                            <div className='row'>
                                <div className='col-sm-12'>
                                    <div className={authoreditStyle.aebiographyBox}>
                                        <div className={authoreditStyle.aebiographyHeader}>
                                            <h4> Biography </h4>
                                            <button className={`${authoreditStyle.editButton} btn btn-light`} onClick={biography}>Edit
                                                <LuPencilLine className={`${authoreditStyle.editButtonicon} ms-1`} />
                                            </button>
                                        </div>
                                        <div className={authoreditStyle.aebiographyBody}>
                                            <p>{user.biography}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-sm-12'>
                                    <div className={authoreditStyle.aeeventdataBox}>
                                        <div className={authoreditStyle.aeeventdataHeader}>
                                            <h4> Events </h4>
                                        </div>
                                        <div className={authoreditStyle.aeeventdataBody}>
                                            <div className='table-responsive'>
                                                <table className="table table-borderless">
                                                    <thead>
                                                        <tr>
                                                            <th>Start & End Date</th>
                                                            <th>School Name</th>
                                                            <th>Location</th>
                                                            <th>POC</th>
                                                            <th className='text-center'>Inscription Report</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {events.length > 0 ? (
                                                            events.map((event, index) => (
                                                                <tr key={index}>
                                                                    <td>{formatEventDate(event.event_start_date)} –{" "} {formatEventDate(event.event_end_date)}</td>
                                                                    <td>{event.school_name}</td>
                                                                    <td>{event.event_location}</td>
                                                                    <td></td>
                                                                    <td></td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="5" className="text-center">
                                                                    No events found
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-sm-12'>
                                    <div className={authoreditStyle.aebooklistbox}>
                                        <div className={authoreditStyle.aebooklistheader}>
                                            <h4> Book List </h4>
                                            <button className={`${authoreditStyle.editButton} btn btn-light`} onClick={bookListpop}>Edit
                                                <LuPencilLine className={`${authoreditStyle.editButtonicon} ms-1`} />
                                            </button>
                                        </div>
                                        <div className={authoreditStyle.aebooklistBody}>
                                            <div className='table-responsive'>
                                                <table className="table table-borderless table-striped">
                                                    <thead>
                                                        <tr style={{}}>
                                                            <th style={{ width: '300px', paddingLeft: '10px' }}>Title</th>
                                                            <th className='text-center'>ISBN</th>
                                                            <th className='text-end' style={{ paddingRight: '10px' }}>Price</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {visibleBooks.map((book, index) => (
                                                            <tr key={index}>
                                                                <td style={{
                                                                    width: '300px',
                                                                    paddingLeft: '10px'
                                                                }}>{book.title}</td>
                                                                <td className='text-center'>{book.isbn}</td>
                                                                <td className='text-end' style={{ paddingRight: '10px' }}>${book.price}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                            {authorsbook.length > 3 && (
                                                <div className='text-center'>
                                                    <SeeMoreButton expanded={expanded} onClick={() => setExpanded(!expanded)} />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-sm-12'>
                                    <div className={authoreditStyle.aenoteBox}>
                                        <div className={authoreditStyle.aenoteHeader}>
                                            <h4> Note to Audience </h4>
                                            <button className={`${authoreditStyle.editButton} btn btn-light`} onClick={notetoFamily}>Edit
                                                <LuPencilLine className={`${authoreditStyle.editButtonicon} ms-1`} />
                                            </button>
                                        </div>
                                        <div className={authoreditStyle.aenotebody}>
                                            <p>{user.notetofamilies}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-sm-12'>
                                    <div className={authoreditStyle.aenoteBox}>
                                        <div className={authoreditStyle.aenoteHeader}>
                                            <h4> Note to Host </h4>
                                            <button className={`${authoreditStyle.editButton} btn btn-light`} onClick={notetoHost}>Edit
                                                <LuPencilLine className={`${authoreditStyle.editButtonicon} ms-1`} />
                                            </button>
                                        </div>
                                        <div className={authoreditStyle.aenotebody}>
                                            <p>{user.notetohost}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

